import React from 'react'

const CheckIcon = ({ color = '#fff' }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.95852 14.6458C7.84741 14.6458 7.74324 14.6283 7.64602 14.5933C7.54879 14.5588 7.45852 14.4999 7.37518 14.4166L3.79185 10.8333C3.63907 10.6805 3.56602 10.4824 3.57268 10.2391C3.57991 9.99631 3.65991 9.79853 3.81268 9.64575C3.96546 9.49297 4.15991 9.41658 4.39602 9.41658C4.63213 9.41658 4.82657 9.49297 4.97935 9.64575L7.95852 12.6249L15.021 5.56242C15.1738 5.40964 15.3719 5.33325 15.6152 5.33325C15.858 5.33325 16.0557 5.40964 16.2085 5.56242C16.3613 5.7152 16.4377 5.91297 16.4377 6.15575C16.4377 6.39909 16.3613 6.59714 16.2085 6.74992L8.54185 14.4166C8.45852 14.4999 8.36824 14.5588 8.27102 14.5933C8.17379 14.6283 8.06963 14.6458 7.95852 14.6458Z"
        fill={color}
      />
    </svg>
  )
}

export default CheckIcon
